// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__d4D6Q","bigColWidth":"Table_bigColWidth__2Akzx","biggerColWidth":"Table_biggerColWidth__1o0i_","row":"Table_row__179_8","col":"Table_col__2QGyM"};